import React from 'react'
import { Route, Switch, Router } from 'react-router-dom'
import { Provider } from 'react-redux'
import asyncComponent from 'components/async-component'
import BackSoon from 'scenes/back-soon'
import history from 'services/utility/common/history'
import configureStore from 'stores/configureStore'

const ContentPage = asyncComponent(() => import('scenes/content-page'))

const App = () => (
  <Provider store={configureStore()}>
    <Router history={history}>
      <Switch>
        <Route exact path="/" component={ContentPage} />
        <Route exact path="/back-soon" component={BackSoon} />
        <Route path="/:param?" component={ContentPage} />
      </Switch>
    </Router>
  </Provider>
)

export default App



// WEBPACK FOOTER //
// ./components/app/index.js